export default "__VITE_ASSET__C1HN9tWn__"